export const VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS   = 'VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS'
export const VUEX_PREMEDIA_ADD_ROW                 = 'VUEX_PREMEDIA_ADD_ROW'
export const VUEX_PREMEDIA_UPDATE_ROW_PROP         = 'VUEX_PREMEDIA_UPDATE_ROW_PROP'
export const VUEX_PREMEDIA_JOB_UPDATE_PROP         = 'VUEX_PREMEDIA_JOB_UPDATE_PROP'
export const VUEX_PREMEDIA_JOB_UPDATE_PROP_CLEAR   = 'VUEX_PREMEDIA_JOB_UPDATE_PROP_CLEAR'
export const VUEX_PREMEDIA_SAVE_ROW                = 'VUEX_PREMEDIA_SAVE_ROW'
export const VUEX_PREMEDIA_SAVE_ROW_SUCCESS        = 'VUEX_PREMEDIA_SAVE_ROW_SUCCESS'
export const VUEX_PREMEDIA_CANCEL_EDIT             = 'VUEX_PREMEDIA_CANCEL_EDIT'
export const VUEX_PREMEDIA_EDIT_ROW                = 'VUEX_PREMEDIA_EDIT_ROW'
export const VUEX_PREMEDIA_DELETE_ROW              = 'VUEX_PREMEDIA_DELETE_ROW'
export const VUEX_PREMEDIA_CREATE_ITEM             = 'VUEX_PREMEDIA_CREATE_ITEM'
export const VUEX_PREMEDIA_CREATE_ITEM_SUCCESS     = 'VUEX_PREMEDIA_CREATE_ITEM_SUCCESS'
export const VUEX_PREMEDIA_UPDATE_ITEM_PROP        = 'VUEX_PREMEDIA_UPDATE_ITEM_PROP'
export const VUEX_PREMEDIA_UPDATE_ITEM             = 'VUEX_PREMEDIA_UPDATE_ITEM'
export const VUEX_PREMEDIA_UPDATE_ITEM_SUCCESS     = 'VUEX_PREMEDIA_UPDATE_ITEM_SUCCESS'
export const VUEX_PREMEDIA_EDIT_ITEM               = 'VUEX_PREMEDIA_EDIT_ITEM'
export const VUEX_PREMEDIA_EDIT_ITEM_SUCCESS       = 'VUEX_PREMEDIA_EDIT_ITEM_SUCCESS'
export const VUEX_PREMEDIA_DELETE_ITEM             = 'VUEX_PREMEDIA_DELETE_ITEM'
export const VUEX_PREMEDIA_DELETE_ITEM_SUCCESS     = 'VUEX_PREMEDIA_DELETE_ITEM_SUCCESS'
export const VUEX_PREMEDIA_CLEAR_DATA              = 'VUEX_PREMEDIA_CLEAR_DATA'

export const VUEX_PREMEDIA_GET_PRODUCTS            = 'VUEX_PREMEDIA_GET_PRODUCTS'
export const VUEX_PREMEDIA_GET_PRODUCTS_SUCCESS    = 'VUEX_PREMEDIA_GET_PRODUCTS_SUCCESS'
export const VUEX_PREMEDIA_GET_PRODUCTS_FAILURE    = 'VUEX_PREMEDIA_GET_PRODUCTS_FAILURE'
export const VUEX_PREMEDIA_ADD_PRODUCT             = 'VUEX_PREMEDIA_ADD_PRODUCT'
export const VUEX_PREMEDIA_UPDATE_PRODUCT_TERM     = 'VUEX_PREMEDIA_UPDATE_PRODUCT_TERM'
export const VUEX_PREMEDIA_CLEAR_PRODUCT_DATA      = 'VUEX_PREMEDIA_CLEAR_PRODUCT_DATA'

export const VUEX_PREMEDIA_GET_ASSETS              = 'VUEX_PREMEDIA_GET_ASSETS'
export const VUEX_PREMEDIA_GET_ASSETS_SUCCESS      = 'VUEX_PREMEDIA_GET_ASSETS_SUCCESS'
export const VUEX_PREMEDIA_GET_ASSETS_FAILURE      = 'VUEX_PREMEDIA_GET_ASSETS_FAILURE'
export const VUEX_PREMEDIA_ADD_ASSET               = 'VUEX_PREMEDIA_ADD_ASSET'
export const VUEX_PREMEDIA_UPDATE_ASSET_TERM       = 'VUEX_PREMEDIA_UPDATE_ASSET_TERM'
export const VUEX_PREMEDIA_CLEAR_ASSET_DATA        = 'VUEX_PREMEDIA_CLEAR_ASSET_DATA'

export const VUEX_PREMEDIA_CLONE_DATA              = 'VUEX_PREMEDIA_CLEAR_ASSET_DATA'

export const VUEX_PREMEDIA_ATTACH_FILE             = 'VUEX_PREMEDIA_ATTACH_FILE'
export const VUEX_PREMEDIA_REMOVE_FILE             = 'VUEX_PREMEDIA_REMOVE_FILE'
export const VUEX_PREMEDIA_REMOVE_FILE_SUCCESS     = 'VUEX_PREMEDIA_REMOVE_FILE_SUCCESS'
export const VUEX_PREMEDIA_PUSH_ATTACHMENTS_REMOVED     = 'VUEX_PREMEDIA_PUSH_ATTACHMENTS_REMOVED'

export const VUEX_PREMEDIA_SET_CANCEL              = 'VUEX_PREMEDIA_SET_CANCEL'
